<template>
  <div id="customer">
    <div class="clearfix">
    <h5 class="float-left">{{ customer.Name }}</h5>
    <button class="btn btn-secondary float-right" @click="$router.go(-1)">
      <i class="fas fa-reply"></i>
    </button>
  </div>
    <div class="card">
      <div class="card-header" @click="toggleShow('address')">
        <h5 class="align-middle d-inline">Adress</h5>
        <router-link :to="`/customer/edit/${id}`" class="btn btn-info float-right" v-if="showField === 'address'">
          <i class="fas fa-edit"></i>
        </router-link>
      </div>
      <div class="card-body" :class="show('address')">
        <h6 class="card-title">Postadress</h6>
        <p class="card-text">
          {{ customer.Address }}<br>
          {{ customer.PostalCode }} {{ customer.City }}<br>
          {{ customer.Country }}
        </p>

        <h6 class="card-title">Besöksadress</h6>
        <p class="card-text">
          {{ customer.vAddress }}<br>
          {{ customer.vPostalCode }} {{ customer.vCity }}
        </p>

        <h6 class="card-title">Kontaktinfo</h6>
        <p class="card-text">
          {{ customer.Fax }}<br>
          {{ customer.Phone }}<br>
          {{ customer.Email }}<br>
          {{ customer.Web }}<br>
        </p>
      </div>
    </div>
      <div class="card">
        <div class="card-header" @click="toggleShow('contacts')">
          <h5 class="align-middle d-inline">Kontakter</h5>
          <div class="float-right">
            <router-link :to="'/contact/delete/' + selectedContact" class="btn btn-info" :class="{ invisible: !selectedContact}">
              <i class="fas fa-trash"></i>
            </router-link>
            <router-link :to="'/contact/edit/' + selectedContact" class="btn btn-info" :class="{ invisible: !selectedContact}">
              <i class="fas fa-edit"></i>
            </router-link>
            <router-link :to="`/customers/${id}/add-outlook-contact`" class="btn btn-info">
              <i class="fas fa-user-plus"></i>
            </router-link>
            <router-link :to="'/customer/' + id + '/contact/add'" class="btn btn-info">
              <i class="fas fa-plus"></i>
            </router-link>
          </div>
        </div>
      </div>
        <div :class="show('contacts')">
        <div class="card" v-for="c in customer.contacts" :key="c.ContactId" @click="selectContact(c.ContactId)" :class="contactBg(c.ContactId)">
          <div class="card-body">
          {{ c.Firstname + ' ' + c.Lastname }}<br>
          {{ c.Position }}<br>
          <a :href="'tel:' + c.Mobile">{{ c.Mobile }}</a><br>
          <a :href="'mailto:' + c.Email">{{ c.Email }}</a>
          </div>
       </div>
       </div>

       <div class="card">
        <div class="card-header" @click="toggleShow('notes')">
          <h5 class="align-middle d-inline">Noteringar</h5>
          <div class="float-right">
            <router-link :to="'/customer/' + id + '/note/delete/' + selectedNote" class="btn btn-info" :class="{ invisible: !selectedNote}">
              <i class="fas fa-trash"></i>
            </router-link>
            <router-link :to="'/customer/' + id + '/note/edit/' + selectedNote" class="btn btn-info" :class="{ invisible: !selectedNote}">
              <i class="fas fa-edit"></i>
            </router-link>
            <router-link :to="'/customer/' + id + '/note/add'" class="btn btn-info" @click.stop>
              <i class="fas fa-plus"></i>
            </router-link>
          </div>
        </div>
      </div>
        <div :class="show('notes')">
          <div class="card" v-for="n in customer.notes" :key="n.CustomerNoteId" @click="selectNote(n.CustomerNoteId)" :class="noteBg(n.CustomerNoteId)">
            <div class="card-body">
              {{ n.Notes }}
            </div>
        </div>
       </div>

      <div class="card">
        <div class="card-header" @click="toggleShow('notifications')">
          <h5 class="align-middle d-inline">Bevakningar</h5>
          <div class="float-right">
            <router-link :to="`/customers/${id}/notifications/delete/${selectedNotification}`" class="btn btn-info" :class="{ invisible: !selectedNotification}">
              <i class="fas fa-trash"></i>
            </router-link>
            <router-link :to="`/customers/${id}/notifications/edit/${selectedNotification}`" class="btn btn-info" :class="{ invisible: !selectedNotification}">
              <i class="fas fa-edit"></i>
            </router-link>
            <router-link :to="`/customers/${id}/notifications/add`" class="btn btn-info" @click.stop>
              <i class="fas fa-plus"></i>
            </router-link>
          </div>
        </div>
      </div>
      <div :class="show('notifications')">
        <div class="card" v-for="n in customer.notifications" :key="n.MessageId" @click="selectNotification(n.MessageId)" :class="notificationBg(n.MessageId)">
          <div class="card-body">
            <strong>{{ n.MessageDate.substring(0, 10) }}</strong>
            {{ n.MessageText }}
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import appService from '@/appService'

export default {
  props: ['id'],

  data () {
    return {
      customer: {},
      showField: '',
      selectedContact: null,
      selectedNote: null,
      selectedNotification: null
    }
  },

  created () {
    appService.getCustomerFull(this.id).then(res => {
      this.customer = res
    })

    if (this.$route.query.c) {
      this.selectedContact = parseInt(this.$route.query.c)
      this.showField = 'contacts'
    }
  },

  methods: {
    selectContact (id) {
      if (this.selectedContact === id) {
        this.selectedContact = null
      } else {
        this.selectedContact = id
      }
    },

    selectNote (id) {
      if (this.selectedNote === id) {
        this.selectedNote = null
      } else {
        this.selectedNote = id
      }
    },

    show (field) {
      return [
        this.showField === field ? 'collapse.show' : 'collapse'
      ]
    },

    selectNotification (id) {
      if (this.selectedNotification === id) {
        this.selectedNotification = null
      } else {
        this.selectedNotification = id
      }
    },

    toggleShow (field) {
      if (this.showField === field) {
        this.showField = ''
      } else {
        this.showField = field
      }

      this.selectedContact = null
      this.selectedNote = null
      this.selectedNotification = null
    },

    contactBg (id) {
      return [
        id === this.selectedContact ?  'text-white bg-info' : ''
      ]
    },

    noteBg (id) {
      return [
        id === this.selectedNote ?  'text-white bg-info' : ''
      ]
    },

    notificationBg (id) {
      return [
        id === this.selectedNotification ?  'text-white bg-info' : ''
      ]
    }

  }
}
</script>
<style scoped>
  .bg-info a:link {
    color: white;
  }

  #customer {
    user-select: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/Customer.vue